import React, { useEffect, useState } from 'react';
import Header from '../../Partials/Header';
import characters from '../../../assets/images/homepage-characters.png';
import reloadIcon from '../../../assets/images/reload.png';
import downloadIcon from '../../../assets/images/download.png';
import './styles.scss';
import { Trans } from 'react-i18next';
import axios from 'axios';
import { NavLink, useLocation } from 'react-router-dom';
import Footer from '../../Partials/Footer';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';

type FormationResultsProps = {
  username: string | null,
  activeNav: boolean,
  language: string,
  setActiveNav: React.Dispatch<React.SetStateAction<boolean>>,
  setLanguage: React.Dispatch<React.SetStateAction<string>>,
  toggleNavbar: () => boolean | void
}

function FormationResults({ username, activeNav, setActiveNav, language, setLanguage, toggleNavbar }: FormationResultsProps) {  

  const location = useLocation();
  const formation= location.state.formation;
  const questionsState = location.state.questions;
  const credentials = localStorage.getItem('credentials');
  const mode = localStorage.getItem('mode');
  
  const [questions, setQuestions] = React.useState(questionsState);
  const [pdfData, setPdfData] = useState(String);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [validationModalIsOpen, setValidationModalIsOpen] = useState(false);
  const [smsModalIsOpen, setSmsModalIsOpen] = useState(false);
  const [codeSms, setCodeSms] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '90%',
      height: '80%',
      borderRadius: '0.5rem',
      padding: '0.5rem',
    },
  };
  
  const customStylesDesktop = {
    content: {
      top: '45%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginLeft: '8rem',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '50rem',
      height: '35rem',
      borderRadius: '1rem',
      padding: '1rem'
    },
  };

  const customSmsModal = {
    content: {
      top: '40%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '80%',
      borderRadius: '0.5rem',
      padding: '2rem',
    },
  };

  const customSmsModalDesktop = {
    content: {
      top: '45%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginLeft: '8rem',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '20rem',
      height: '20rem',
      borderRadius: '1rem',
      padding: '1rem'
    },
  };

  Modal.setAppElement('body');

  const getQuestions = (userFormationId, formationId) => {    
    axios.get(`${process.env.REACT_APP_DOMAIN_API}:${process.env.REACT_APP_DOCKER_API_PORT}/api/userQuestions/${userFormationId}/${formationId}`, {
      headers: {
        Authorization: `Bearer ${credentials}`
      }
  })
    .then((response) => {
      setQuestions(response.data);
    })
    .catch((error) => {
      if (error.status === 404) {
        throw new Error('404');
      }
    })
  }

  const getUserFormation = async (userFormationId) => {
    await axios.get(`${process.env.REACT_APP_DOMAIN_API}:${process.env.REACT_APP_DOCKER_API_PORT}/api/userFormation/${userFormationId}`,)
      .then(response => {
        response.data.transmittedOn === null ? setValidationModalIsOpen(true) : setValidationModalIsOpen(false);
      }).catch(error => {
        if (error.response.status === 404) {
          throw new Error('no user formations found');
        }
      })
  }

  const getSmtCode = async () => {
    await axios.post(`${process.env.REACT_APP_DOMAIN_API}:${process.env.REACT_APP_DOCKER_API_PORT}/api/formation_sms`, {
      cleint: localStorage.getItem('cleint'),
      type: 'valid_f3s_away'
    })
    .then(response => {
      if (response.status === 200) {
        toast.success('Code envoyé par SMS');
        localStorage.setItem('phone', response.data.contact.sms);
        localStorage.setItem('cleint', response.data.cleint);
      }
    }).catch(error => {
      toast.error('Erreur lors de l\'envoi du code par SMS');
      throw new Error('404');
    })
  }

  const getMapiDiploma = async (codeSms: null | string, phone: null | string, userFormationId: null | number) => {
    setIsLoading(true);
    await axios.get(`${process.env.REACT_APP_DOMAIN_API}:${process.env.REACT_APP_DOCKER_API_PORT}/api/tests/diploma`, {
      params: {
        cleint: localStorage.getItem('cleint'),
        call: phone,
        code: codeSms,
        userFormation: userFormationId
      },
    })
    .then(response => {
      if (response.status === 200) {
        setIsLoading(false);
        toast.success('Diplôme téléchargé');
        setPdfData(response.data);
      } else {
        setIsLoading(false);
        toast.error('Erreur lors de la récupération du diplôme');
      }

    }).catch(error => {
      setIsLoading(false);
      toast.error('Erreur lors de la récupération du diplôme');
      throw new Error('404');
    })
  }

  useEffect(() => {
    getQuestions(questionsState[0].userFormationId, questionsState[0].Question.formationId);
    getUserFormation(questionsState[0].userFormationId);
  }, [questionsState])

  const numberOfGoodAnswers = questions.filter((question: any) => question.status === 'success').length;

  return (
    <div className={isLoading ? "Login-loading": "HomePage"}>
      {isLoading && (
        <div className="Login-loader" />
      )}
        <Header language={language} setLanguage={setLanguage} username={username} activeNav={activeNav} setActiveNav={setActiveNav} toggleNavbar={toggleNavbar}/>
        
        <main className={!activeNav ? 'HomePage-main' : 'HomePage-main--blur'} onClick={() => {
          if (activeNav && (window.innerWidth < 900)) {
            toggleNavbar()
          }
        }}>
            {pdfData && modalIsOpen && (
              <Modal
                isOpen={modalIsOpen}
                style={(window.innerWidth > 900) ? customStylesDesktop : customStyles}
                contentLabel="Diploma"
                onRequestClose={() => {
                  modalIsOpen ? setModalIsOpen(false) : setModalIsOpen(true);
                }}
              >
                <embed src={`data:application/pdf;base64,${pdfData}`} type="application/pdf" 
                  style={{
                  width: '100%',
                  height: '100%',
                  top: '50',
                  left: '50',
                }}/>
              </Modal>
            )}

            {validationModalIsOpen && (
              <Modal
                isOpen={validationModalIsOpen}
                style={(window.innerWidth > 900) ? customSmsModalDesktop : customSmsModal}
                contentLabel="SmsModal"
                onRequestClose={() => {
                  validationModalIsOpen ? setValidationModalIsOpen(false) : setValidationModalIsOpen(true);
                }}
              >
                <h3 className="FormationResults-title">
                  Valider mon test F3S
                </h3>
                  {mode === 'jeton' &&
                    <div className="FormationResults-sms">
                      <p className="FormationResults-sendSms">
                        Un code vous sera transmis par SMS afin d'envoyer vos résultats.
                      </p>
                        <button className="FormationResults-smsButton"
                          onClick={() => {
                            setValidationModalIsOpen(false);
                            setSmsModalIsOpen(true);
                            getSmtCode();
                          }}
                        >
                          Valider mon test F3S
                        </button>
                    </div>
                  }
                  {mode === 'code' &&
                    <div className="FormationResults-sms">
                      <p className="FormationResults-sendSms">
                      Veuillez-vous valider les résultats de votre test pour récupérer votre diplôme?
                      </p>
                        <button className="FormationResults-smsButton"
                          onClick={() => {
                            setValidationModalIsOpen(false);
                            setModalIsOpen(true);
                            getMapiDiploma(mode, null, questionsState[0].userFormationId);
                          }}
                        >
                          Valider mon test F3S
                        </button>
                    </div>
                  }
              </Modal>
            )}

            {smsModalIsOpen && (
              <Modal
                isOpen={smsModalIsOpen}
                style={(window.innerWidth > 900) ? customSmsModalDesktop : customSmsModal}
                contentLabel="SmsModal"
                onRequestClose={() => {
                  smsModalIsOpen ? setSmsModalIsOpen(false) : setSmsModalIsOpen(true);
                }}
              >
                <h3 className="FormationResults-title">
                  Télécharger mon diplôme
                </h3>
                <div className="FormationResults-sms">
                  <p className="FormationResults-sendSms">
                    Un code de validation vous a été transmis par SMS.
                  </p>
                  <form className="FormationResults-sendSmsForm">
                    <input
                      type="text"
                      className="FormationResults-smsInput"
                      placeholder="Code de validation"
                      value={codeSms}
                      onChange={(e) => setCodeSms(e.target.value)} />
                    <button className="FormationResults-smsButton"
                      onClick={() => {
                        setCodeSms('');
                        setSmsModalIsOpen(false);
                        setModalIsOpen(true);
                        getMapiDiploma(codeSms, localStorage.getItem('phone'), questionsState[0].userFormationId);
                      }}
                    >
                      Valider
                    </button>
                  </form>
                </div>
              </Modal>
            )}

          <section className={!activeNav ? 'HomePage-welcome' : 'HomePage-welcome--blur'} style={{height: 'auto', paddingBottom: '2rem'}}>
            <img className="HomePage-welcome--image" src={characters} alt="Dummy et copine de Dummy" />
            {numberOfGoodAnswers === questions.length && (
              <>
                <p className="HomePage-welcome--text">
                  <Trans>FormationResults.Congrats.Intro</Trans>
                <br />
                  <Trans>FormationResults.Congrats.Phrase</Trans>
                </p>
                <div className="FormationResults-buttons">
                  <NavLink to={`/question/${questions[0].questionId}`} state={{questions: questions, question: questions[0].Question, formation: formation}}>
                  </NavLink>
                    <button 
                      className="FormationResults-retry"
                      style={(window.innerWidth > 900) ? {marginLeft: '1rem', marginRight: '1rem'} : {marginTop: '0', marginBottom: '0'}}
                      onClick={() => {
                        getMapiDiploma(null, null, questionsState[0].userFormationId);
                        setModalIsOpen(true);
                      }}  
                    >
                      <img src={downloadIcon} className="FormationResults-retry--icon"  />
                        Télécharger mon diplôme
                    </button>
                    <NavLink to ="/">
                      <button className='FormationResults-retry' style={{padding: '1rem'}}>
                        <FontAwesomeIcon icon={faHome} style={{marginRight: '0.5rem'}} />
                        Revenir à l'accueil
                      </button>
                    </NavLink>
                </div>
              </>
            )}
            {numberOfGoodAnswers !== questions.length && (
              <>
                <p className="HomePage-welcome--text">
                  <Trans>FormationResults.Failed.Intro</Trans>          
                </p>
                <p className="HomePage-welcome--text">
                  <Trans>FormationResults.Failed.Phrase</Trans>
                </p>
                <div className="FormationResults-buttons">
                  <NavLink to={`/question/${questions[0].questionId}`} state={{questions: questions, question: questions[0].Question, formation: formation}}>
                    <button className="FormationResults-retry">
                      <img src={reloadIcon} alt="reload" className="FormationResults-retry--icon" />
                        Refaire l’intégralité de la formation
                    </button>
                  </NavLink>
                  <button
                      className="FormationResults-retry"
                      style={(window.innerWidth > 900) ? {marginLeft: '1rem', marginRight: '1rem'} : {marginTop: '0', marginBottom: '0'}}
                      onClick={() => {
                        getMapiDiploma(null, null, questionsState[0].userFormationId);
                        setModalIsOpen(true);
                      }}
                    >
                      <img src={downloadIcon} className="FormationResults-retry--icon"  />
                        Télécharger mon diplôme
                  </button>
                  <NavLink to ="/">
                    <button className='FormationResults-retry' style={{padding: '1rem'}}>
                      <FontAwesomeIcon icon={faHome} style={{marginRight: '0.5rem'}} />
                      Revenir à l'accueil
                    </button>
                  </NavLink>
                </div>
              </>
            )}
          </section>

          <section className={!activeNav ? "FormationResults" : "FormationResults--blur"}>
            <h3 className="FormationResults-title">
              Formation {formation.Formation.name}
            </h3>

            <h4 className="FormationResults-subtitle"
              style={numberOfGoodAnswers !== questions.length ? {color: '#E70F47', backgroundColor: '#FFE1E9', padding: '0.5rem', borderRadius: '0.5rem'} : {color: '#26A653', backgroundColor: '#DDFFE9', padding: '0.5rem', borderRadius: '0.5rem'}}
            >
              {numberOfGoodAnswers} bonnes réponses sur {questions.length}
            </h4>
            <ul className="FormationResults-block">
              {questions.map((question: any) => (
                <NavLink key={question.questionId} to={`/question/${question.questionId}`} state={{questions: questions, question: question.Question, formation: formation}}>
                  <li key={question.questionId} className="FormationResults-block--question"
                    style={question.status === 'waiting' ? {color: '#E70F47'} : {color: '#323BA2'}}
                  >
                    {question.Question.number}. {question.Question.intro_text_panel}
                  </li>
                </NavLink>
              ))}
              <div className='FormationResults-bar'></div>
            </ul>
          </section>

          
        </main>
        <Footer />
    </div>
  );
}

export default FormationResults;
